import React, { FC } from "react";
import { TableRow as MuiTableRow } from "@mui/material";

type Props = React.ComponentProps<typeof MuiTableRow>;

const TableRow: FC<Props> = (props) => {
    return <MuiTableRow {...props}/>
}

export default TableRow;